const FromArr = [{
		title: "经销商名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 25,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "授权编号：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 45,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "产品线：",
		inputtype: "select",
		multiple: true,
		collapseTags: true,
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 45,
		marginTop: 10,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		title: "授权有效日期：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "发布时间",
		heightLeft: 32,
		heightRight: 32,
		widthLeft: 150,
		widthRight: 150,
		disabled: false,
		marginLeft: 10,
		marginTop: 24,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "生成日期：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "发布时间",
		heightLeft: 32,
		heightRight: 32,
		widthLeft: 150,
		widthRight: 150,
		disabled: false,
		marginLeft: 75,
		marginTop: 24,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "医院：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 66,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "审核状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 45,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		hidden: false,
		title: "是否上传盖章：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 5,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [{
				key: 1,
				value: '是'
			},
			{
				key: 0,
				value: '否'
			}
		]
	},
	{
		title: "生产厂商：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 40,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		title: "业务员：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 45,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "产品名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 45,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 500
	}
];
export default FromArr;